import { useApolloClient, useSubscription } from '@apollo/client/react';
import { useEffect, useMemo } from 'react';
import { debounce } from 'es-toolkit';
import { DocumentStatusUpdatedDocument } from '@/graphql';
import { refreshInvoiceLists } from '../utils/refresh-invoice-lists';

/** A batch upload finishes many documents at once — one refresh per burst is enough. */
const REFRESH_DEBOUNCE_MS = 500;

/**
 * Keeps the invoice list and its tab counts current when an extraction produces an invoice.
 * A document reaches COMPLETED only once its invoice row exists.
 */
export function useInvoiceLiveRefresh(): void {
  const client = useApolloClient();

  const refresh = useMemo(
    () => debounce(() => void refreshInvoiceLists(client), REFRESH_DEBOUNCE_MS),
    [client]
  );

  useEffect(() => () => refresh.cancel(), [refresh]);

  useSubscription(DocumentStatusUpdatedDocument, {
    onData: ({ data }) => {
      if (data.data?.documentStatusUpdated?.status === 'COMPLETED') refresh();
    }
  });
}
